define([
    'backbone',
    'appcontext'
], (Backbone, appContext) => {

    const DirtyTracker = function () {
        this.reset();

        const self = this;
        this.modelChanged = function (model) {
            self.dirty(model.cid);
        };
    };

    _.extend(DirtyTracker.prototype, Backbone.Events, {

        reset () {
            if (this.trackingModels) {
                this.untrack();
            }
            this.trackingModels = [];
            this.clear();
        },

        clear () {
            this.dirtyMap = {};
            this.dirtyCount = 0;
            this.trigger('change', false);
        },

        track () {
            _.each(arguments, function (model) {
                this.trackingModels.push(model);
                model.on('change', this.modelChanged);
            }, this);
        },

        untrack () {
            const models = arguments.length ? arguments : this.trackingModels.slice();
            _.each(models, function (model) {
                model.off('change', this.modelChanged);
                this.trackingModels.splice(this.trackingModels.indexOf(model), 1);
                this.undirty(model.cid);
            }, this);
        },

        dirty (key) {
            if (!this.isDirty(key)) {
                this.dirtyMap[key] = true;
                this.dirtyCount += 1;

                if (this.dirtyCount === 1) {
                    this.trigger('change', true);
                }
            }
        },

        undirty (key) {
            if (this.isDirty(key)) {
                delete this.dirtyMap[key];
                this.dirtyCount -= 1;

                if (this.dirtyCount === 0) {
                    this.trigger('change', false);
                }
            }
        },

        isDirty (key) {
            if (_.isUndefined(key)) {
                return this.dirtyCount > 0;
            }
            return key in this.dirtyMap;

        },

        unsavedMessage () {
            return appContext.tr('You have unsaved changes.');
        },

        unsavedMessageFull () {
            return '{0} {1}'.format(this.unsavedMessage(), appContext.tr('Are you sure you want to leave this page?'));
        }
    });

    return new DirtyTracker();

});
